import React from 'react';
import { Typography } from '@mui/material';

const Purchases = () => {
    return (
        <div>
            <Typography sx={{ fontWeight: 600, m: 5, color: 'white' }} variant="h4" component="div">
                Development Pending:
            </Typography>
        </div>
    );
};

export default Purchases;